import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { appI, desktopI } from './DesktopSlice.types'

const initialState: desktopI = {
  apps: [],
  page: '',
  loading: true
}

export const desktopSlice = createSlice({
  name: 'desktop',
  initialState,
  reducers: {
    changeDesktopPage: (state, { payload }: PayloadAction<string>) => {
      state.page = payload
    },
    setApps: (state, { payload }: PayloadAction<{ apps: appI[] }>) => {
      state.apps = payload.apps
    },
    setDesktopLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload
    }
  }
})

export const { changeDesktopPage, setApps, setDesktopLoading } =
  desktopSlice.actions
